import React, { useEffect, useState } from "react";
import HeaderLogo from "../../assets/img/src/shingan_logo_gr-wh.png";
import HeaderLogoRow from "../../assets/img/src/shingan_logo_row.png";
import { Link, animateScroll as scroll } from "react-scroll";
import { DrawerMenu } from ".";
import "../../assets/css/header.css";

const scrollToTop = () => {
  scroll.scrollToTop();
};

const HeaderMenu = () => {
  const [isHeightOver, setIsHeightOver] = useState(false);

  useEffect(() => {
    const scrollAction = () => {
      if (320 > window.scrollY) {
        setIsHeightOver(true);
      } else {
        setIsHeightOver(false);
      }
    };
    window.addEventListener("scroll", scrollAction, {
      capture: false,
      passive: true,
    });
    scrollAction();
  }, []);

  return (
    <>
      <div
        className={
          isHeightOver ? "header-container" : "header-container--white"
        }
      >
        <div className="flex-row">
          <img
            className={
              isHeightOver ? "logo-title hover1" : "logo-title--row hover1"
            }
            src={isHeightOver ? HeaderLogo : HeaderLogoRow}
            alt="ロゴ画像"
            onClick={scrollToTop}
          />
          <div className="header-flex-row mobile-none">
            <div className="row-spacer--l" />
            <div className="row-spacer--l" />
            <div className="row-spacer--l" />
            <div className="row-spacer--l" />
            <div
              className={
                isHeightOver
                  ? "header-text hover1"
                  : "header-text--black hover1"
              }
            >
              <Link
                to="about"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                概要
              </Link>
            </div>

            <div
              className={
                isHeightOver
                  ? "header-text hover1"
                  : "header-text--black hover1"
              }
            >
              <Link
                to="merit"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                メリット
              </Link>
            </div>
            <div
              className={
                isHeightOver
                  ? "header-text hover1"
                  : "header-text--black hover1"
              }
            >
              <Link
                to="contact"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                お問い合わせ
              </Link>
            </div>

            <div className="row-spacer--l" />
          </div>
          <div className="header-menu flex-row--justright header-text">
            <DrawerMenu />
          </div>
          <div className="row-spacer--l" />
        </div>
      </div>
      {/* <div className="header-container--foundation"></div> */}
    </>
  );
};

export default HeaderMenu;
